<template>
  <nav class="nav right">
    <div class="mobile-nav">
      <div
        class="visitor-ham-menu"
        @click="toggleMenu"
      >
        <img
          v-if="menuOpen"
          src="../../../images/menuClose.svg"
          alt="open mobile menu"
        >
        <img
          v-else
          src="../../../images/menuIcon.svg"
          alt="close mobile menu"
        >
      </div>
    </div>

    <ul
      id="mobile-menu"
      class="nav-list"
    >
      <li class="nav-item">
        <ServiceNavLinkComponent />
      </li>
      <li
        v-for="item in navItems"
        :key="item.name"
        class="nav-item"
      >
        <router-link
          :id="item.id"
          :to="item.link"
          class="nav-link"
          :class="{button: item.is_button, 'nrn-legal-button': item.id === 'nrn-legal'}"
        >
          {{ item.name }}
        </router-link>
      </li>
    </ul>
  </nav>
</template>

<script>
import {ref} from 'vue'
import ServiceNavLinkComponent from '@/components/LandingPage/Header/ServiceNavLinkComponent.vue'

export default {
  name: 'NavBar',
  components: {ServiceNavLinkComponent},
  setup() {
    const navItems = ref([
       {name: 'Reviews', link: '/review', id: 'reviews'},
       {name: 'NRN Legal', link: '/nrn-service', id: 'nrn-legal', is_button: {button: true}},
        {name: 'Login', link: '/SignIn', id: 'login', is_button: {button: true}},
        // {name: 'Sign Up', link: '/SignUpChooseUser', id: 'signup', is_button: {button: true}},
      ])
    const menuOpen = ref(false)
    const toggleMenu = () => {
      let menu = document.querySelector('#mobile-menu')

      if (menu.classList.contains('nav-open')) {
        menu.classList.remove('nav-open')
        menuOpen.value = false
      } else {
        menu.classList.add('nav-open')
        menuOpen.value = true
      }
    }
    return {
      navItems,
      menuOpen,
      toggleMenu,
    }
  },
}
</script>
